import { GTextField } from '~/presentation/ui';
import { useState, useCallback } from 'react';
import { cls } from '~/utils';

interface InputActivatorProps {
  value: string;
  placeholder?: string;
  isActive?: boolean;
  customFocus?: boolean;
  fullWidth?: boolean;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onEnter?: (value: string) => void;
}

export const InputActivator: React.FC<InputActivatorProps> = ({
  value,
  placeholder,
  isActive = false,
  customFocus = false,
  fullWidth = false,
  onChange,
  onFocus,
  onBlur,
  onEnter,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = useCallback(() => {
    setIsFocused(true);
    onFocus?.();
  }, [onFocus]);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
    onBlur?.();
  }, [onBlur]);

  return (
    <div
      className={cls({
        'w-full': fullWidth,
        'Polaris-GInputActivator is-active': customFocus && (isActive || isFocused),
      })}
    >
      <GTextField
        label=""
        labelHidden
        focused={isFocused}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onEnter={onEnter}
        placeholder={placeholder}
        autoComplete="off"
      />
    </div>
  );
};
